import { useEffect, useState } from 'react';
import { resolveLegalRegion, TERMS_PATHS, type LegalRegion } from '../lib/legalRegion';

export function useLegalRegion() {
  const [region, setRegion] = useState<LegalRegion | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    resolveLegalRegion()
      .then((resolved) => {
        if (isMounted) setRegion(resolved);
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return {
    region,
    documentPath: region ? TERMS_PATHS[region] : null,
    isLoading,
  };
}
